import { Fragment } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonBirthplaceCrumbs } from 'civil-status/constants/place';
import FormPlace from 'civil-status/components/place/form';
import { useParams } from 'react-router-dom';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponse } from 'shell/models/http-response';
import { PlaceForm } from 'civil-status/view-models/place';
import { transformResponse } from 'civil-status/utils/place';
import { __ACT_API_URL__ } from 'shell/constants/environment';
import { MunicipalityValueDomainType } from 'shell/models/value-domain-type';
import { DomainType } from 'civil-status/constants/domain';

const BirthplaceDetailPage = (): React.ReactElement => {
  const params = useParams();

  const [birthplaceData] = useHttpFetch<HttpResponse<MunicipalityValueDomainType>, PlaceForm>(
    `${__ACT_API_URL__}/valori-dominio-atti/luogo-codificato/${DomainType.Birthplace}/${params.id}`,
    {
      onBootstrap: true,
      options: {
        method: 'GET',
        loading: true,
        errorCatching: true,
      },
      transformer: transformResponse,
    }
  );

  const values = birthplaceData.data as PlaceForm;

  return (
    <Fragment>
      <Breadcrumbs items={[...CommonBirthplaceCrumbs, { name: 'Visualizza luogo nascita' }]} />
      {birthplaceData.isLoading || birthplaceData.pristine || birthplaceData.error ? undefined : (
        <FormPlace title="Visualizza luogo nascita" disabled initialValues={values} />
      )}
    </Fragment>
  );
};

BirthplaceDetailPage.displayName = 'Birthplace detail page component';

export default BirthplaceDetailPage;
